// extracted by mini-css-extract-plugin
module.exports = {"row":"BuyXFreeXModalCardButtons_row__1bkVu","quantity":"BuyXFreeXModalCardButtons_quantity__FFrJz","button":"BuyXFreeXModalCardButtons_button__3tfW3"};